import consignorMiddleware from './consignor/middleware';
import consigneeMiddleware from './consignee/middleware';

const personMiddleware = [consignorMiddleware, consigneeMiddleware];
export default personMiddleware;
